class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = null;
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onHoverMediaChange = this.onHoverMediaChange.bind(this);

    this.bindHoverListeners(this.hoverMedia.matches);
    this.hoverMedia.addEventListener('change', this.onHoverMediaChange);
  }

  disconnectedCallback() {
    this.hoverMedia.removeEventListener('change', this.onHoverMediaChange);
    this.clearCloseDelay();
    this.unbindHoverListeners();
  }

  bindHoverListeners(enabled) {
    if (enabled) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      return;
    }

    this.unbindHoverListeners();
  }

  unbindHoverListeners() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onHoverMediaChange(event) {
    this.bindHoverListeners(event.matches);
    if (!event.matches) this.clearCloseDelay();
  }

  onMouseEnter() {
    if (!this.hoverMedia.matches) return;

    this.clearCloseDelay();
    this.closeSiblingMenus();
    this.openFromHover();
  }

  onMouseLeave() {
    if (!this.hoverMedia.matches) return;

    this.closeDelay = window.setTimeout(() => {
      this.close();
      this.closeDelay = null;
    }, 160);
  }

  clearCloseDelay() {
    if (!this.closeDelay) return;
    window.clearTimeout(this.closeDelay);
    this.closeDelay = null;
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      menu.clearCloseDelay();
      menu.close();
    });
  }

  openFromHover() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  close() {
    this.clearCloseDelay();
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
